import { render } from "./UserProfile.vue?vue&type=template&id=63a28434"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
script.render = render

export default script